/**
 * US phone number utilities — mobile and landline are treated equally.
 *
 * Accepted input examples (all normalise to "+1 (555) 000-0000"):
 *   5550001234  •  555-000-1234  •  (555) 000-1234
 *   +1 555 000 1234  •  1-555-000-1234
 */

/**
 * Format a raw phone string into "+1 (XXX) XXX-XXXX" as the user types.
 * Strips non-digit characters, keeps the +1 country code prefix.
 */
export function formatUSPhone(raw) {
  // Strip everything except digits
  const digits = raw.replace(/\D/g, '');

  // Remove leading 1 (country code) so we always work with 10 digits
  const local = digits.startsWith('1') ? digits.slice(1) : digits;

  if (local.length === 0) return '';
  if (local.length <= 3) return `+1 (${local}`;
  if (local.length <= 6) return `+1 (${local.slice(0, 3)}) ${local.slice(3)}`;
  return `+1 (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6, 10)}`;
}

/**
 * Returns true if `value` is a valid US phone number (10 local digits,
 * optional +1 country code, various separators).
 */
export function isValidUSPhone(value) {
  if (!value) return false;
  const digits = value.replace(/\D/g, '');
  // With country code → 11 digits starting with 1, without → 10 digits
  if (digits.length === 11 && digits.startsWith('1')) return true;
  if (digits.length === 10) return true;
  return false;
}

/**
 * Convenience handler for onChange events on phone inputs.
 * Formats the value and calls the provided setter.
 */
export function handlePhoneChange(rawValue, setter) {
  setter(formatUSPhone(rawValue));
}
